type CrudOperations = 'add' | 'view' | 'update' | 'delete' | 'create'
type OwnOperations = 'own'
type BulkOpertions = 'bulk_update' | 'bulk_delete'

//#region lead / opp entities
type EntityOperations = CrudOperations | OwnOperations | BulkOpertions
export type PermissionEntity = 'leads' | 'opportunities' | 'pending_leads'
type EntityPermOps = `${PermissionEntity}_${EntityOperations}`
//#endregion

//#region accounts
type LocationPermOps = 'accounts_update'
export type LocationCreatePermOps = 'accounts_create'

//#endregion
type ReportsPermOps = 'reports_view'
type SettingsPermOps = 'settings_show_admin_users_in_owner_dropdowns'
export const SettingsAdminPermOps =
  'settings_show_admin_users_in_owner_dropdowns'
type OppConvertPermOps = 'opportunities_convert_/_save_for_later'
type CloseLostOpp = 'opportunities_cancel_closed/lost_services'
type LeadOverrideAutomatedAssignment = 'leads_override_automated_assignment'
type OtherPermOps = 'other_delete_knock_status_history'

export type PermOp =
  | EntityPermOps
  | LocationPermOps
  | ReportsPermOps
  | LocationCreatePermOps
  | SettingsPermOps
  | OppConvertPermOps
  | LeadOverrideAutomatedAssignment
  | CloseLostOpp
  | OtherPermOps
